import type { CSSProperties } from 'react';
import { Tooltip } from './Tooltip';

// 개선계획 §2/§3/§9 — '신규'(한 번도 고객 출고되지 않음) 배지.
//
// StatusPill 을 쓰지 않는 이유: '신규'는 로봇의 **상태**(RobotStatus)가 아니라
// 출고 이력에서 파생된 속성이다. 같은 색 점 + 알약으로 그리면 운영자가 상태
// 값으로 읽는다("신규라는 상태가 있나?"). 그래서 점 없이 테두리만 있는 다른
// 형태로 분리한다.
//
// 배지 예산: 한 줄에 상태 1 + 일치도 1 + 신규 1 을 넘기지 않는다(디자인 리뷰).
// 애니메이션 없음 — pulse 는 긴급(SLA 초과) 전용이다(kuun 규칙 4).

const TOOLTIP = '한 번도 고객사로 출고된 적이 없는 로봇입니다. 행사·전시 반출은 포함하지 않습니다.';

const badgeStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '1px 6px',
  borderRadius: 999,
  fontSize: 10,
  fontWeight: 700,
  lineHeight: 1.5,
  letterSpacing: '0.02em',
  background: 'transparent',
  border: '1.5px solid var(--border-info-saturated)',
  color: 'var(--fg-on-info-tint)',
  whiteSpace: 'nowrap',
};

export function NewBadge() {
  return (
    <Tooltip content={TOOLTIP}>
      <span style={badgeStyle} data-testid="new-badge">
        신규
      </span>
    </Tooltip>
  );
}

// 재고 현황의 SN 칩처럼 배지를 놓을 자리가 없는 좁은 표면용 — 칩 앞에 붙는
// 작은 점 하나로 같은 뜻을 전한다(툴팁으로 의미를 밝힌다).
const dotStyle: CSSProperties = {
  display: 'inline-block',
  width: 6,
  height: 6,
  borderRadius: '50%',
  background: 'var(--fg-on-info-tint)',
  flex: 'none',
};

export function NewDot() {
  return (
    <Tooltip content={TOOLTIP}>
      <span style={dotStyle} data-testid="new-dot" aria-label="신규" role="img" />
    </Tooltip>
  );
}
